/* Font loading helpers shared by the Stickered builders.
   - stkFontIndexFetch: the font list is kept in localStorage for a day and
     returned instantly; a fresh copy is fetched in the background for next time.
   - stkLazyFont: a font-list tile gets its font as soon as it scrolls into view,
     and every listed font is also preloaded quietly in the background (16 at a
     time, in list order) a moment after the page loads, so the whole list is
     ready before it opens instead of filling in one by one. The preload is
     skipped on Data Saver / 2G, where tiles still load as they scroll in. */
(function(){
  if (window.stkFontIndexFetch) return;
  var KEY = 'stk-font-index-v1';
  var TTL = 24 * 60 * 60 * 1000;
  function fresh(url) {
    return fetch(url).then(function(res){
      if (!res.ok) return res;
      return res.clone().text().then(function(text){
        try { localStorage.setItem(KEY, JSON.stringify({ url: url, at: Date.now(), text: text })); } catch (e) {}
        return res;
      });
    });
  }
  window.stkFontIndexFetch = function(url) {
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (cached && cached.url === url && cached.text && Date.now() - cached.at < TTL) {
      fresh(url).catch(function(){});
      return Promise.resolve(new Response(cached.text, { status: 200, headers: { 'Content-Type': 'application/json' } }));
    }
    return fresh(url);
  };

  var queue = [], queued = {}, active = 0, LIMIT = 16, scheduled = false, warming = false;
  function slowConnection() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  }
  function pump() {
    while (warming && active < LIMIT && queue.length) {
      active++;
      document.fonts.load('16px ' + queue.shift()).catch(function(){}).then(function(){ active--; pump(); });
    }
  }
  function scheduleWarm() {
    if (scheduled || slowConnection() || !document.fonts || !document.fonts.load) return;
    scheduled = true;
    var go = function(){
      setTimeout(function(){
        (window.requestIdleCallback || function(f){ f(); })(function(){ warming = true; pump(); }, { timeout: 3000 });
      }, 1000);
    };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      entry.target.style.fontFamily = entry.target.getAttribute('data-stk-lazy-font');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '150px' }) : null;
  window.stkLazyFont = function(el, family) {
    if (!queued[family]) { queued[family] = true; queue.push(family); scheduleWarm(); pump(); }
    if (!observer) { el.style.fontFamily = family; return; }
    el.setAttribute('data-stk-lazy-font', family);
    observer.observe(el);
  };
})();

(function(){
  if (window.__stickeredBoatNameBuilderGlobalReady) return;
  window.__stickeredBoatNameBuilderGlobalReady = true;

  function initStickeredBoatNameBuilder(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var section = root.closest('[id^="ProductSection-"]') || document;
    var preview = root.querySelector('.stk-boat-preview-text');
    var fontButton = root.querySelector('.stk-boat-font-button');
    var fontLabel = root.querySelector('.stk-boat-font-label');
    var fontList = root.querySelector('.stk-boat-font-list');
    var fontName = root.querySelector('.stk-boat-font-name');
    var propFont = root.querySelector('.stk-boat-prop-font');
    var numberWarning = root.querySelector('.stk-boat-number-warning');

    if (!preview || !fontButton || !fontLabel || !fontList) return;

    // The hidden Font property lives inside this Custom HTML block, which
    // Easify does not render as a descendant of the actual <form> — without
    // an explicit form="" attribute, FormData silently drops it and the Font
    // never reaches the order at all.
    if (propFont) {
      var formId = root.getAttribute('data-product-form') || (section.querySelector('form[action*="/cart/add"]') || {}).id;
      if (formId) propFont.setAttribute('form', formId);
    }

    var fontsBase = 'https://lzakvswydjwhynzrwold.supabase.co/storage/v1/object/public/fonts';
    var fontsIndexUrl = 'https://flow.stickered.co.nz/api/public/fonts';
    var currentFont = { name: 'Default', css: 'Arial, sans-serif' };
    var input = null;

    function findBoatNameInput() {
      var byName = section.querySelector('input[name="properties[Boat Name]"]:not([type="hidden"]), textarea[name="properties[Boat Name]"]');
      if (byName) return byName;

      var candidates = section.querySelectorAll('input, textarea, [class*="po-textField-input"], [class*="po-textField-textarea"]');
      var fallback = null;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var fieldRoot = el.closest('[class*="po-field-root"]');
        var labelEl = fieldRoot && fieldRoot.querySelector('[class*="po-label-root"], [class*="po-label-label"], label');
        var labelText = labelEl ? labelEl.textContent : '';
        if (!fallback && labelText && /boat/i.test(labelText)) fallback = el;
        if (labelText && /boat\s*name/i.test(labelText)) return el;
      }
      return fallback;
    }

    function getInput() {
      return findBoatNameInput() || input;
    }

    // Prefer the exact element an event fired on over a fresh DOM query —
    // Easify's React layer can re-render the field between keystrokes, and a
    // fresh query can momentarily return a not-yet-updated node, which showed
    // up as the preview lagging one character behind while typing.
    function getPreviewValue(explicitInput) {
      var activeInput = explicitInput || getInput();
      return activeInput && activeInput.value ? activeInput.value : 'Boat Name';
    }

    function setFontPreviewContent(target, value, name) {
      if (!target) return;
      target.textContent = '';

      var sample = document.createElement('span');
      sample.className = 'stk-boat-font-sample';
      sample.textContent = value;

      var nameEl = document.createElement('span');
      nameEl.className = 'stk-boat-font-option-name';
      nameEl.textContent = ' (' + name + ')';
      nameEl.style.fontFamily = 'Arial, sans-serif';
      nameEl.style.fontSize = '10px';
      nameEl.style.fontWeight = '700';
      nameEl.style.letterSpacing = '.04em';
      nameEl.style.color = '#777';
      nameEl.style.verticalAlign = 'middle';
      nameEl.style.textTransform = 'uppercase';

      target.appendChild(sample);
      target.appendChild(nameEl);
    }

    function refreshFontOptionLabels(explicitValue) {
      var value = explicitValue || getPreviewValue();
      Array.prototype.forEach.call(fontList.children, function(item){
        setFontPreviewContent(item, value, item.getAttribute('data-name') || 'Default');
        item.setAttribute('title', item.getAttribute('data-name') || value);
      });
    }

    function fitPreviewText() {
      var baseFontSize = 40;
      preview.style.fontSize = baseFontSize + 'px';
      requestAnimationFrame(function(){
        var box = preview.parentNode;
        if (!box) return;
        var styles = getComputedStyle(box);
        var available = box.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
        var width = preview.scrollWidth;
        if (width > available && width > 0) {
          preview.style.fontSize = Math.max(14, Math.floor(baseFontSize * (available / width))) + 'px';
        }
      });
    }

    function updateNumberWarning(explicitInput) {
      if (!numberWarning) return;
      var activeInput = explicitInput || getInput();
      var hasNumber = /\d/.test(activeInput ? activeInput.value || '' : '');
      numberWarning.hidden = !hasNumber;
      numberWarning.style.display = hasNumber ? 'flex' : 'none';
    }

    function update(explicitInput) {
      var activeInput = explicitInput || getInput();
      var value = getPreviewValue(activeInput);

      preview.textContent = value;
      preview.style.fontFamily = currentFont.css;
      fitPreviewText();

      if (activeInput && activeInput.classList.contains('stk-boat-input')) {
        activeInput.style.fontFamily = currentFont.css;
      }

      setFontPreviewContent(fontLabel, value, currentFont.name);
      fontLabel.style.fontFamily = currentFont.css;

      if (fontName) fontName.textContent = currentFont.name !== 'Default' ? '(' + currentFont.name + ')' : '';
      if (propFont) propFont.value = currentFont.name;

      refreshFontOptionLabels(value);
      updateNumberWarning(activeInput);
    }

    function bindInput(nextInput) {
      if (!nextInput || nextInput === input) return;
      input = nextInput;
      if (input.dataset.stkBoatBound !== 'true') {
        input.dataset.stkBoatBound = 'true';
        input.addEventListener('input', function(e){ update(e.target); });
        input.addEventListener('change', function(e){ update(e.target); });
      }
      update(nextInput);
    }

    function buildFonts(fonts) {
      var oldStyle = document.getElementById('stk-boat-custom-font-faces');
      if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);

      var styleEl = document.createElement('style');
      styleEl.id = 'stk-boat-custom-font-faces';
      fontList.innerHTML = '';

      if (!Array.isArray(fonts) || !fonts.length) {
        currentFont = { name: 'Default', css: 'Arial, sans-serif' };
        fontLabel.textContent = 'Default';
        update();
        return;
      }

      fonts.forEach(function(font, index){
        var family = 'stk-boat-font-' + index;
        var formatMap = { ttf: 'truetype', otf: 'opentype', woff: 'woff', woff2: 'woff2' };
        var rawFormat = (font.format || 'truetype').toLowerCase();
        var format = formatMap[rawFormat] || rawFormat;
        var url = font.url || fontsBase + '/' + encodeURIComponent(String(font.file).normalize('NFKD').replace(/[^A-Za-z0-9._-]+/g, '_'));

        styleEl.appendChild(document.createTextNode(
          "@font-face{font-family:'" + family + "';src:url('" + url + "') format('" + format + "');font-display:swap;}"
        ));

        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.setAttribute('data-name', font.name);
        item.setAttribute('data-css', "'" + family + "', sans-serif");
        setFontPreviewContent(item, getPreviewValue(), font.name);
        item.setAttribute('title', font.name);
        window.stkLazyFont(item, "'" + family + "', sans-serif");
        fontList.appendChild(item);
      });

      document.head.appendChild(styleEl);

      var first = fontList.querySelector('li');
      if (first) {
        first.setAttribute('aria-selected', 'true');
        currentFont = {
          name: first.getAttribute('data-name'),
          css: first.getAttribute('data-css')
        };
      }

      update();
    }

    fontButton.addEventListener('click', function(){
      refreshFontOptionLabels();
      fontList.hidden = !fontList.hidden;
      fontButton.setAttribute('aria-expanded', fontList.hidden ? 'false' : 'true');
    });

    fontList.addEventListener('click', function(event){
      var item = event.target.closest('li');
      if (!item) return;

      Array.prototype.forEach.call(fontList.children, function(child){
        child.removeAttribute('aria-selected');
      });

      item.setAttribute('aria-selected', 'true');
      currentFont = {
        name: item.getAttribute('data-name'),
        css: item.getAttribute('data-css')
      };

      fontList.hidden = true;
      fontButton.setAttribute('aria-expanded', 'false');
      update();
    });

    document.addEventListener('click', function(event){
      if (!root.contains(event.target)) {
        fontList.hidden = true;
        fontButton.setAttribute('aria-expanded', 'false');
      }
    });

    section.addEventListener('input', function(event){
      if (event.target && event.target.matches('input, textarea')) {
        var labelEl = event.target.closest('[class*="po-field-root"]');
        labelEl = labelEl && labelEl.querySelector('[class*="po-label-root"], [class*="po-label-label"], label');
        if (labelEl && /boat\s*name/i.test(labelEl.textContent)) {
          bindInput(event.target);
          update(event.target);
        }
      }
    }, true);
    section.addEventListener('change', function(event){
      if (event.target && event.target.matches('input, textarea')) {
        var labelEl = event.target.closest('[class*="po-field-root"]');
        labelEl = labelEl && labelEl.querySelector('[class*="po-label-root"], [class*="po-label-label"], label');
        if (labelEl && /boat\s*name/i.test(labelEl.textContent)) {
          bindInput(event.target);
          update(event.target);
        }
      }
    }, true);

    // ----- Preferred Size vs. selected Size validation -----
    function findFieldByLabel(labelPattern, selector) {
      var labels = section.querySelectorAll('[class*="po-label-label"], [class*="po-label-root"], label');
      for (var i = 0; i < labels.length; i++) {
        if (!labelPattern.test(labels[i].textContent)) continue;
        var fieldRoot = labels[i].closest('[class*="po-field-root"]') || labels[i].closest('.tpo_option-container');
        if (!fieldRoot) continue;
        var el = selector ? fieldRoot.querySelector(selector) : fieldRoot;
        if (el) return el;
      }
      return null;
    }

    function getSelectedSizeText() {
      var fieldRoot = null;
      var labels = section.querySelectorAll('[class*="po-label-label"], [class*="po-label-root"], label');
      for (var i = 0; i < labels.length; i++) {
        // Easify appends " *" to required field labels, so this can't be an
        // exact "Size" match — it must allow trailing characters (the same
        // bug hid the mm limit from ever being found at all).
        if (!/^size\b/i.test(labels[i].textContent.trim())) continue;
        fieldRoot = labels[i].closest('[class*="po-field-root"]') || labels[i].closest('.tpo_option-container');
        break;
      }
      if (!fieldRoot) return '';

      var closedButton = fieldRoot.querySelector('[class*="po-select-button"]');
      if (closedButton && closedButton.textContent.trim()) return closedButton.textContent.trim();

      var checkedInput = fieldRoot.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (checkedInput) {
        var optionLabel = checkedInput.closest('[class*="po-radioGroup-item"], [class*="po-optionItemLabel"]') || checkedInput.parentElement;
        if (optionLabel) return optionLabel.textContent.trim();
      }

      var nativeSelect = fieldRoot.querySelector('select');
      if (nativeSelect && nativeSelect.selectedOptions && nativeSelect.selectedOptions[0]) {
        return nativeSelect.selectedOptions[0].textContent.trim();
      }

      return '';
    }

    function maxMmFromLabel(label) {
      var m = label.match(/(\d+(?:\.\d+)?)\s*mm/gi);
      if (!m) return null;
      var nums = m.map(function(x){ return parseFloat(x); });
      return Math.max.apply(null, nums);
    }

    function maxMmFromInput(val) {
      var m = val.match(/(\d+(?:\.\d+)?)/g);
      if (!m) return null;
      var nums = m.map(function(x){ return parseFloat(x); });
      return Math.max.apply(null, nums);
    }

    function getOrCreateSizeWarning(preferredInput) {
      var existing = section.querySelector('.stk-boat-size-warning');
      if (existing) return existing;
      var warn = document.createElement('div');
      warn.className = 'stk-boat-size-warning';
      warn.style.cssText = 'display:none;margin-top:8px;padding:10px 12px;border:1px solid #f0b4b4;border-radius:6px;background:#fdecec;color:#c81e1e;font-size:13px;font-weight:600;';
      var fieldRoot = preferredInput.closest('[class*="po-field-root"]') || preferredInput.closest('.tpo_option-container') || preferredInput.parentElement;
      fieldRoot.parentElement.insertBefore(warn, fieldRoot.nextSibling);
      return warn;
    }

    function validatePreferredSize() {
      var preferredInput = findFieldByLabel(/preferred size/i, 'input, textarea');
      if (!preferredInput) return true;
      var warn = getOrCreateSizeWarning(preferredInput);

      var sizeLabel = getSelectedSizeText();
      var limit = sizeLabel ? maxMmFromLabel(sizeLabel) : null;
      var entered = maxMmFromInput(preferredInput.value || '');

      if (limit && entered && entered > limit) {
        warn.textContent = 'Size entered (' + entered + 'mm) is larger than the size limit chosen (' + limit + 'mm).';
        warn.style.display = 'block';
        preferredInput.setCustomValidity(warn.textContent);
        return false;
      }

      warn.style.display = 'none';
      preferredInput.setCustomValidity('');
      return true;
    }

    function bindPreferredSizeValidation() {
      // Delegated on the section, not bound to specific nodes once — Easify's
      // React layer can replace both the Preferred Size input and the Size
      // field between renders (the same issue fixed for Boat Name earlier),
      // so a one-time direct binding can silently go stale.
      if (section.dataset.stkBoatSizeDelegated === 'true') return;
      section.dataset.stkBoatSizeDelegated = 'true';

      section.addEventListener('input', function(event){
        if (event.target && event.target.matches('input, textarea')) {
          var labelEl = event.target.closest('[class*="po-field-root"]');
          labelEl = labelEl && labelEl.querySelector('[class*="po-label-root"], [class*="po-label-label"], label');
          if (labelEl && /preferred size/i.test(labelEl.textContent)) validatePreferredSize();
        }
      }, true);
      section.addEventListener('change', function(event){
        if (event.target && event.target.matches('input, textarea')) {
          var labelEl = event.target.closest('[class*="po-field-root"]');
          labelEl = labelEl && labelEl.querySelector('[class*="po-label-root"], [class*="po-label-label"], label');
          if (labelEl && /preferred size/i.test(labelEl.textContent)) validatePreferredSize();
        }
      }, true);

      // Selecting a Size value isn't a plain input/change on a form field in
      // Easify's UI — it's a click inside the dropdown/option list — so this
      // is a broader delegated click watcher scoped to the Size field only.
      section.addEventListener('click', function(event){
        var labelEl = event.target.closest('[class*="po-field-root"]');
        labelEl = labelEl && labelEl.querySelector('[class*="po-label-root"], [class*="po-label-label"], label');
        if (labelEl && /^size\b/i.test(labelEl.textContent.trim())) {
          setTimeout(validatePreferredSize, 150);
        }
      }, true);

      var form = section.querySelector('form[action*="/cart/add"]');
      if (form && form.dataset.stkBoatSizeSubmitBound !== 'true') {
        form.dataset.stkBoatSizeSubmitBound = 'true';
        form.addEventListener('submit', function(e){
          if (!validatePreferredSize()) {
            var preferredInput = findFieldByLabel(/preferred size/i, 'input, textarea');
            e.preventDefault();
            e.stopPropagation();
            if (preferredInput) preferredInput.reportValidity && preferredInput.reportValidity();
          }
        }, true);
      }
    }

    bindPreferredSizeValidation();
    window.addEventListener('resize', fitPreviewText);

    window.stkFontIndexFetch(fontsIndexUrl)
      .then(function(response){ return response.ok ? response.json() : []; })
      .then(buildFonts)
      .catch(function(){ buildFonts([]); });

    bindInput(findBoatNameInput());
    update();
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('[data-stk-boat-builder]').forEach(initStickeredBoatNameBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initAll(event.target);
  });

  if (window.MutationObserver) {
    var queued = false;
    var observer = new MutationObserver(function(){
      if (queued) return;
      queued = true;
      setTimeout(function(){
        queued = false;
        initAll(document);
      }, 100);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function(){ observer.disconnect(); }, 30000);
  }
})();
